import { reactive, toRefs } from '@vue/composition-api';
import { loginUserModule } from '@/store/modules/LoginUserStore';

export const usePortalAppBar = () => {
  const portalAppBarProps = reactive({
    loading: false,
    userInfo: loginUserModule.userInfo,
  });
  return toRefs(portalAppBarProps);
};
